import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '../store'

// Correct implementation
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: (selector: (state: RootState) => void) => any = useSelector
